<template>
  <div>
    <div id="ueCard" class="invisible-card no-padding">
      <div id="title-group">
        <div id="hidden-text-part">
          <h1>{{ name }}</h1>
          <p>{{ description }}</p>
        </div>
        <div id="text-part">
          <h1>{{ name }}</h1>
          <p>{{ description }}</p>
        </div>
        <div id="over-img"></div>
        <img class="ue-img hidden-image" :src="baseURL + 'img/home/low/' + code + '-low.png'" alt="" onload="this.classList.remove('hidden-image')">
      </div>

    </div>
    <div id="subjects_container">
      <router-link
          v-for="(subject, index) in subjects" :key="index"
          :to="`/${$route.params.name}/quiz/${subject._id}`"
          class="subject_part card">
          <h4 class="subject_title">{{ subject.spliced.name }}</h4>
          <span v-if="subject.spliced.detail">{{ subject.spliced.detail }}</span>
          <span>{{ subject.quiz.length }} QCM & questions.</span>
      </router-link>
    </div>
    <router-link
        :to="`/${$route.params.name}/test`"
        id="testCard" class="invisible-card">
      <h4 id="play_button">▶</h4>
      <h4 class="subject_title">Lancer un entrainement pour toute l'UE</h4>
    </router-link>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ue",
  data() {
    return {
      name: '',
      code: '',
      description: 'Vous trouverez ci-dessous tous les QCM de cette UE.',
      subjects: [],
      baseURL: axios.defaults.baseURL
    }
  },
  async created() {
    try {
      let ue_data = (await axios.get(`/ue/findByLink/${this.$route.params.name}`)).data
      if (!ue_data) {
        this.name = 'Oups, on dirait que vous vous êtes perdu !'
        this.description = "Cette UE n'existe pas. Retournez à l'accueil pour sélectionner une des UE disponibles."
      }

      this.name = ue_data.name
      this.code = ue_data.code
      this.subjects = ue_data.subjects.map(s => {
        let detail = /(.+?)\((.+)\)|(.+)/gi.exec(s.name)
        s.spliced = {name: detail[1] ? detail[1] : detail[0], detail: detail[2] ? detail[2] : false}
        return s
      })
    } catch (e) {
      console.log(e)
    }
  },
  mounted() {
    window.scrollTo(0, 0)
  }
}
</script>

<style scoped>
  #ueCard, #testCard {
    width: 75%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
  }
  #title-group {
    position: relative;
    height: 40px;
    padding: 15px 30px;
    margin-left: 30px;
    margin-bottom: 50px;
  }
  #text-part {
    position: absolute;
    z-index: 54;
    top: 0;
  }
  #hidden-text-part {
    opacity: 0;
    padding: 20px 40px;
  }
  .ue-img {
    z-index: 50;
    position: absolute;
    top: -15px;
    left: -30px;
    height: calc(100% + 30px);
    border-radius: 7px;
  }
  #over-img {
    z-index: 52;
    height: calc(100% + 30px);
    aspect-ratio: 1;
    position: absolute;
    top: -15px;
    left: -30px;
    box-shadow: inset -80px 0 35px -20px var(--color-background);
    transition: var(--transition-duration-color);
  }
  .hidden-image {
    opacity: 0;
    transition: .2s;
  }
  #testCard {
    display: block;
  }
  #testCard > * {
    display: inline-block;
  }
  #play_button {
    margin-right: 10px;
  }
  #subjects_container {
    width: 75%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 17px;
    justify-content: center;
    align-items: center;
  }

  .subject_part {
    box-sizing: border-box;
    margin: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
  }
  .subject_title {
    position: relative;
  }
  .subject_title:after {
    content: "";
    position: absolute;
    top: 19px;
    left: 0;
    height: 1px;
    background-color: var(--color-text-3);
    width: 0;
    transition: .2s;
  }
  .subject_part:hover > .subject_title:after {
    width: 100%;
  }
  #testCard:hover > .subject_title:after {
    width: 100%;
  }
  .subject_part:hover, #testCard:hover {
    background-color: var(--color-selected-hover);
  }

  @media screen and (max-width: 1400px) {
    #ueCard, #testCard {
      width: 85%;
      margin-bottom: 20px;
    }
    #subjects_container {
      width: 85%;
      gap: 10px;
    }
    .subject_part {
      flex-grow: 1;
    }
  }
  @media screen and (max-width: 720px) {
    #ueCard, #testCard {
      width: 96%;
      margin-bottom: 12px;
    }
    #subjects_container {
      width: 96%;
      gap: 5px;
    }
    .subject_part {
      width: 100%;
    }
    #title-group {
      margin-left: 10px;
    }
  }
</style>